import React, { useContext } from 'react'
import { SingleSelectionGroup } from '@paypalcorp/pp-react'
import { CleverContext } from './cleverContext'

/**
 * This is a functional component that takes input of desired payment day
 * @returns {JSX.Element} - A JSX element
 */
const PaymentDaySelector: React.FC = () => {
  const { paymentDay, setPaymentDay } = useContext(CleverContext)
  return (
    <SingleSelectionGroup
      name="weekly-payment-day"
      label="Weekly Payment Day"
      value={paymentDay}
      responsive="sm"
      onChange={(e) => setPaymentDay(e.target.value)}
      options={[
        {
          label: 'Monday',
          value: 'MONDAY',
        },
        {
          label: 'Tuesday',
          value: 'TUESDAY',
        },
        {
          label: 'Wednesday',
          value: 'WEDNESDAY',
        },
        {
          label: 'Thursday',
          value: 'THURSDAY',
        },
        {
          label: 'Friday',
          value: 'FRIDAY',
        },
      ]}
    />
  )
}

export default PaymentDaySelector
